const getNewBody = (body = []) => {
    
    const {length} = body
    const n = 12
    if(length<n) return [body]
    const newBody = {}
    let cont = 0

    for(let i = 0; i<length; i++){
        
        if(!newBody[cont]){
            newBody[cont] = []
        }
        newBody[cont].push(body[i])

        if(i>n-1 && i%n===0) cont++

    }

    return newBody

}

const PAYLOAD_CUSTOM_TABLE = {
    body:[],
    head:[],
    startY:0,
}

/**
 * @param {PAYLOAD_CUSTOM_TABLE} payload 
 */
const crearTablaPersonalizada = (payload) => {

    const {body, head, doc, startY} = payload
    const newBody = getNewBody(body)
    const lenghtNewBody = Object.keys(newBody).length

    for(const i in newBody){

        const currentPage = doc.internal.getCurrentPageInfo().pageNumber

        doc.autoTable({
            startY: currentPage==1 ? startY : startY - 40,
            pageBreak: 'avoid',
            headStyles: { fillColor: [239, 154, 154],
                textColor: [0, 0, 0],
                halign: 'center' },
            head,
            body:newBody[i],
            bodyStyles: {
                halign:'center',
            },
            headStyles: {
                lineWidth: 0,
                lineColor: [0, 0, 0],
                textColor:[60,60,60],
                halign:'center',
            },
            styles: { fillColor: "#ffffff" },
        })

        if(Number(i)!==lenghtNewBody-1) doc.addPage()

    }

}

export default {
    crearTablaPersonalizada
}


// WEBPACK FOOTER //
// ./src/vistas/Reportes2/utils/tabla.js